import storage from 'utils/storage';
import * as constants from './constants';

export const deviceInitialState = {
  current: null,
  devices: null,
  situation: null,
};

export const deviceReducer = (
  state = deviceInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.GET_DEVICES_DATA:
      return {
        ...state,
        devices: payload,
      };
    case constants.GET_DEVICE_DATA:
      return {
        ...state,
        current: payload,
      };
    case constants.GET_DEVICE_SITUATION:
      return {
        ...state,
        situation: payload,
      };
    case constants.SET_DEVICE_SITUATION:
      return {
        ...state,
        situation: { ...state.situation, ...payload },
      };
    default:
      return state;
  }
};

export const userDeviceIdReducer = (
  state = storage.get('userDeviceId') || null,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.PUT_CURRENT_USER_DEVICE_ID:
      return payload;
    default:
      return state;
  }
};
